export default __webpack_public_path__ + "fa675e5e4bec9eb250b6a8cac09b189b.ttf";